import { render } from "./SexyEnergyConsumption.vue?vue&type=template&id=32572cd2"
import script from "./SexyEnergyConsumption.vue?vue&type=script&lang=js"
export * from "./SexyEnergyConsumption.vue?vue&type=script&lang=js"

import "./SexyEnergyConsumption.vue?vue&type=style&index=0&id=32572cd2&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__